export const FETCH_PDF_BATCH_STATS_REQUEST =
  'pdfBatchGeneration/FETCH_PDF_BATCH_STATS_REQUEST'
export const FETCH_PDF_BATCH_STATS_SUCCESS =
  'pdfBatchGeneration/FETCH_PDF_BATCH_STATS_SUCCESS'
export const FETCH_PDF_BATCH_STATS_FAILURE =
  'pdfBatchGeneration/FETCH_PDF_BATCH_STATS_FAILURE'

export const FETCH_PDF_BATCH_TASK_STATUS_REQUEST =
  'pdfBatchGeneration/FETCH_PDF_BATCH_TASK_STATUS_REQUEST'
export const FETCH_PDF_BATCH_TASK_STATUS_SUCCESS =
  'pdfBatchGeneration/FETCH_PDF_BATCH_TASK_STATUS_SUCCESS'
export const FETCH_PDF_BATCH_TASK_STATUS_FAILURE =
  'pdfBatchGeneration/FETCH_PDF_BATCH_TASK_STATUS_FAILURE'

export const GENERATE_PDF_BATCH_REQUEST =
  'pdfBatchGeneration/GENERATE_PDF_BATCH_REQUEST'
export const GENERATE_PDF_BATCH_SUCCESS =
  'pdfBatchGeneration/GENERATE_PDF_BATCH_SUCCESS'
export const GENERATE_PDF_BATCH_FAILURE =
  'pdfBatchGeneration/GENERATE_PDF_BATCH_FAILURE'

export const STOP_PDF_BATCH_GENERATION_REQUEST =
  'pdfBatchGeneration/STOP_PDF_BATCH_GENERATION_REQUEST'
export const STOP_PDF_BATCH_GENERATION_SUCCESS =
  'pdfBatchGeneration/STOP_PDF_BATCH_GENERATION_SUCCESS'
export const STOP_PDF_BATCH_GENERATION_FAILURE =
  'pdfBatchGeneration/STOP_PDF_BATCH_GENERATION_FAILURE'

export const UPDATE_FIELD = 'pdfBatchGeneration/UPDATE_FIELD'
export const SET_DEFAULT_DATA = 'pdfBatchGeneration/SET_DEFAULT_DATA'
